export interface ComicChapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: number;
  title: string;
  author: string;
  artist: string;
  category: string;
  categoryLabel: string;
  cover: string;
  description: string;
  chapters: ComicChapter[];
  rating: number;
  views: number;
  status: string;
  tags: string[];
  updatedAt: string;
  createdAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
}

export const categories = [
  { slug: 'all', label: '全部漫画' },
  { slug: 'recommended', label: '热门推荐' },
  { slug: 'romance', label: '恋爱漫画' },
  { slug: 'fantasy', label: '奇幻漫画' },
  { slug: 'action', label: '动作漫画' },
  { slug: 'comedy', label: '搞笑漫画' },
  { slug: 'mystery', label: '悬疑漫画' },
  { slug: 'drama', label: '剧情漫画' },
  { slug: 'thriller', label: '惊悚漫画' },
  { slug: 'historical', label: '古风漫画' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '绝世神医',
    author: '金泰亨',
    artist: '李敏镐',
    category: 'fantasy',
    categoryLabel: '奇幻漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Korean%20manhwa%20cover%20art%20featuring%20an%20elegant%20male%20doctor%20in%20traditional%20hanbok%20with%20flowing%20robes%2C%20holding%20a%20glowing%20golden%20acupuncture%20needle%2C%20mystical%20energy%20swirling%20around%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20golden%20and%20deep%20crimson%20color%20palette%2C%20manhwa%20style%20illustration%20with%20detailed%20linework%20and%20soft%20gradients%2C%20clean%20background%20with%20subtle%20traditional%20pattern%2C%20professional%20digital%20art%20quality&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '天才医学生意外穿越到古代朝鲜，凭借现代医学知识成为一代神医。在宫廷与江湖之间周旋，他用医术救人，用智慧破局。面对权谋斗争和生死考验，他能否改变命运，找到回到现代的方法？一本融合了医疗、权谋与爱情的精彩穿越漫画。',
    chapters: [
      { id: 101, title: '第1话：穿越', number: 1, updatedAt: '2026-08-01' },
      { id: 102, title: '第2话：初显身手', number: 2, updatedAt: '2026-08-02' },
      { id: 103, title: '第3话：宫廷召见', number: 3, updatedAt: '2026-08-03' },
      { id: 104, title: '第4话：暗流涌动', number: 4, updatedAt: '2026-08-04' },
      { id: 105, title: '第5话：妙手回春', number: 5, updatedAt: '2026-08-05' },
    ],
    rating: 4.8,
    views: 152340,
    status: '连载中',
    tags: ['穿越', '医疗', '宫廷', '权谋'],
    updatedAt: '2026-08-05',
    createdAt: '2026-06-01',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 2,
    title: '我的恶魔男友',
    author: '朴秀珍',
    artist: '郑智恩',
    category: 'romance',
    categoryLabel: '恋爱漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20showing%20a%20handsome%20mysterious%20man%20with%20slightly%20sharp%20features%20and%20dark%20hair%20leaning%20close%20to%20a%20shy%20college%20girl%20with%20long%20flowing%20hair%2C%20cherry%20blossom%20petals%20floating%20around%2C%20soft%20pink%20and%20romantic%20atmosphere%2C%20manhwa%20romance%20style%20with%20gentle%20expressions%2C%20dreamy%20bokeh%20background%2C%20warm%20and%20tender%20mood%2C%20clean%20and%20simple%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '普通大学生林小希意外与恶魔签订了契约，被迫与傲慢又迷人的恶魔同居。从互相嫌弃到渐生情愫，一段跨越人魔两界的浪漫爱情故事就此展开。但是，恶魔界的规定不允许与人类相爱，他们将如何面对即将到来的考验？',
    chapters: [
      { id: 201, title: '第1话：契约', number: 1, updatedAt: '2026-08-01' },
      { id: 202, title: '第2话：同居生活', number: 2, updatedAt: '2026-08-03' },
      { id: 203, title: '第3话：心动瞬间', number: 3, updatedAt: '2026-08-05' },
    ],
    rating: 4.6,
    views: 98720,
    status: '连载中',
    tags: ['恋爱', '奇幻', '同居', '校园'],
    updatedAt: '2026-08-05',
    createdAt: '2026-06-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 3,
    title: '暗夜猎手',
    author: '崔志勋',
    artist: '姜东元',
    category: 'action',
    categoryLabel: '动作漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Korean%20action%20manhwa%20cover%20featuring%20a%20cool%20male%20hunter%20in%20black%20tactical%20gear%20with%20a%20long%20coat%2C%20holding%20a%20futuristic%20weapon%2C%20standing%20on%20a%20rooftop%20at%20night%2C%20city%20lights%20below%2C%20moon%20in%20background%2C%20dramatic%20cinematic%20lighting%20with%20neon%20accents%2C%20dark%20atmosphere%2C%20manhwa%20action%20style%20with%20sharp%20linework%20and%20bold%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '在不为人知的暗夜世界，猎人们专门猎杀危害人类的超自然生物。主角韩镇宇是一名退役特种兵，因一次任务意外获得超能力，加入猎人组织。在城市暗影中与各种怪物战斗，揭开隐藏在幕后的惊天阴谋。',
    chapters: [
      { id: 301, title: '第1话：觉醒', number: 1, updatedAt: '2026-07-28' },
      { id: 302, title: '第2话：首次任务', number: 2, updatedAt: '2026-07-30' },
      { id: 303, title: '第3话：暗影来袭', number: 3, updatedAt: '2026-08-02' },
      { id: 304, title: '第4话：绝地反击', number: 4, updatedAt: '2026-08-04' },
    ],
    rating: 4.7,
    views: 210500,
    status: '连载中',
    tags: ['动作', '超能力', '都市', '战斗'],
    updatedAt: '2026-08-04',
    createdAt: '2026-05-20',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 4,
    title: '社长大人请克制',
    author: '尹智慧',
    artist: '孙艺珍',
    category: 'comedy',
    categoryLabel: '搞笑漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Korean%20comedy%20manhwa%20cover%20showing%20a%20handsome%20but%20ridiculous%20CEO%20in%20a%20suit%20making%20a%20silly%20face%20while%20a%20female%20employee%20looks%20exasperated%2C%20office%20setting%2C%20comical%20expressions%2C%20bright%20and%20cheerful%20color%20palette%2C%20manhwa%20comedy%20style%20with%20exaggerated%20features%2C%20clean%20and%20simple%20background%2C%20lighthearted%20and%20humorous%20mood&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '冷面总裁申俊昊私下却是个游戏宅和漫画迷！新入职的秘书发现了他的秘密，从此开启了一段啼笑皆非的办公室生活。社长的双重人格、同事间的搞笑日常，以及办公室里不能说的秘密，全部爆笑揭晓！',
    chapters: [
      { id: 401, title: '第1话：新秘书', number: 1, updatedAt: '2026-08-01' },
      { id: 402, title: '第2话：社长的秘密', number: 2, updatedAt: '2026-08-04' },
    ],
    rating: 4.5,
    views: 76500,
    status: '连载中',
    tags: ['搞笑', '办公室', '恋爱', '日常'],
    updatedAt: '2026-08-04',
    createdAt: '2026-07-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 5,
    title: '迷雾之城',
    author: '韩素希',
    artist: '刘亚仁',
    category: 'mystery',
    categoryLabel: '悬疑漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20mystery%20manhwa%20cover%20depicting%20a%20foggy%20alleyway%20in%20a%20traditional%20Korean%20town%2C%20a%20detective%20figure%20in%20a%20trench%20coat%20silhouetted%20against%20a%20single%20streetlamp%2C%20eerie%20atmosphere%2C%20dark%20and%20moody%20tones%20with%20subtle%20warm%20light%2C%20manhwa%20thriller%20style%20with%20atmospheric%20rendering%2C%20suspenseful%20and%20intriguing%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '在一个被迷雾笼罩的小镇上，连续发生离奇失踪案件。私家侦探朴敏俊接手调查，却发现每个失踪者之间都有着千丝万缕的联系。随着调查深入，一个关于小镇百年前诅咒的秘密逐渐浮出水面。',
    chapters: [
      { id: 501, title: '第1话：失踪者', number: 1, updatedAt: '2026-07-25' },
      { id: 502, title: '第2话：线索', number: 2, updatedAt: '2026-07-28' },
      { id: 503, title: '第3话：古宅', number: 3, updatedAt: '2026-08-01' },
      { id: 504, title: '第4话：诅咒', number: 4, updatedAt: '2026-08-03' },
      { id: 505, title: '第5话：真相', number: 5, updatedAt: '2026-08-05' },
    ],
    rating: 4.9,
    views: 187200,
    status: '已完结',
    tags: ['悬疑', '侦探', '恐怖', '小镇'],
    updatedAt: '2026-08-05',
    createdAt: '2026-04-10',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 6,
    title: '皇后的逆袭',
    author: '全智贤',
    artist: '玄彬',
    category: 'drama',
    categoryLabel: '剧情漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20historical%20manhwa%20cover%20featuring%20a%20beautiful%20queen%20in%20elaborate%20traditional%20Korean%20royal%20hanbok%20with%20intricate%20gold%20embroidery%2C%20standing%20in%20a%20grand%20palace%20hall%2C%20determined%20expression%2C%20dramatic%20lighting%20from%20behind%2C%20rich%20red%20and%20gold%20color%20scheme%2C%20manhwa%20drama%20style%20with%20elegant%20detailing%2C%20regal%20and%20powerful%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '她是被废黜的皇后，遭人陷害流放边疆。三年卧薪尝胆，她以全新身份重回宫廷。昔日仇人已权倾朝野，而她步步为营，用智慧和勇气一点一点夺回属于自己的一切。一场惊心动魄的宫廷复仇大戏就此开启。',
    chapters: [
      { id: 601, title: '第1话：废后', number: 1, updatedAt: '2026-07-20' },
      { id: 602, title: '第2话：流放', number: 2, updatedAt: '2026-07-23' },
      { id: 603, title: '第3话：归来', number: 3, updatedAt: '2026-07-27' },
    ],
    rating: 4.7,
    views: 145600,
    status: '连载中',
    tags: ['宫斗', '复仇', '古装', '女性'],
    updatedAt: '2026-07-27',
    createdAt: '2026-05-01',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 7,
    title: '极速心跳',
    author: '李政宰',
    artist: '河正宇',
    category: 'thriller',
    categoryLabel: '惊悚漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20tense%20Korean%20thriller%20manhwa%20cover%20showing%20a%20man%20running%20through%20a%20dark%20subway%20tunnel%2C%20emergency%20lights%20flashing%20red%2C%20shadowy%20figure%20pursuing%20behind%2C%20intense%20and%20urgent%20atmosphere%2C%20dynamic%20action%20pose%2C%20manhwa%20thriller%20style%20with%20strong%20contrast%20lighting%2C%20cinematic%20composition%2C%20dark%20and%20gritty%20urban%20setting&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '地铁司机金道贤在午夜末班车上目睹了一起谋杀案，从此被卷入一场致命追逐。神秘组织、政府阴谋、时间赛跑——72小时内，他必须找到证据，否则将永远消失。每一秒都可能是最后一秒。',
    chapters: [
      { id: 701, title: '第1话：末班车', number: 1, updatedAt: '2026-08-01' },
      { id: 702, title: '第2话：追杀', number: 2, updatedAt: '2026-08-03' },
    ],
    rating: 4.4,
    views: 43200,
    status: '连载中',
    tags: ['惊悚', '悬疑', '都市', '逃亡'],
    updatedAt: '2026-08-03',
    createdAt: '2026-07-15',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 8,
    title: '花间辞',
    author: '宋慧乔',
    artist: '朴宝剑',
    category: 'historical',
    categoryLabel: '古风漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20historical%20romance%20manhwa%20cover%20showing%20a%20graceful%20woman%20in%20elegant%20traditional%20Korean%20hanbok%20standing%20under%20a%20blooming%20plum%20blossom%20tree%2C%20soft%20petals%20falling%2C%20traditional%20Korean%20garden%20background%20with%20wooden%20pavilion%2C%20gentle%20spring%20light%2C%20romantic%20and%20poetic%20atmosphere%2C%20manhwa%20historical%20style%20with%20delicate%20brush-like%20linework&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '朝鲜时代，一位才女与世子在花间邂逅，以诗词传情。然而身份悬殊、宫廷暗斗，让这段纯美爱情历经磨难。她用才情与坚韧守护爱情，书写了一段跨越阶级的动人传奇。画风唯美，故事催泪。',
    chapters: [
      { id: 801, title: '第1话：花间初遇', number: 1, updatedAt: '2026-07-15' },
      { id: 802, title: '第2话：诗词相和', number: 2, updatedAt: '2026-07-18' },
      { id: 803, title: '第3话：风云突变', number: 3, updatedAt: '2026-07-22' },
      { id: 804, title: '第4话：离别', number: 4, updatedAt: '2026-07-26' },
      { id: 805, title: '第5话：重逢', number: 5, updatedAt: '2026-07-30' },
      { id: 806, title: '第6话：终章', number: 6, updatedAt: '2026-08-02' },
    ],
    rating: 4.9,
    views: 267800,
    status: '已完结',
    tags: ['古风', '恋爱', '宫廷', '才女'],
    updatedAt: '2026-08-02',
    createdAt: '2026-03-01',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 9,
    title: '修仙从零开始',
    author: '金南佶',
    artist: '丁海寅',
    category: 'fantasy',
    categoryLabel: '奇幻漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20cultivation%20manhwa%20cover%20featuring%20a%20young%20male%20cultivator%20in%20flowing%20traditional%20robes%20with%20glowing%20spiritual%20energy%20surrounding%20him%2C%20floating%20in%20the%20air%20above%20a%20misty%20mountain%20peak%2C%20magical%20runes%20and%20symbols%20in%20the%20air%2C%20celestial%20beings%20in%20the%20distant%20sky%2C%20mystical%20blue%20and%20golden%20color%20palette%2C%20manhwa%20fantasy%20style%20with%20ethereal%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '资质平庸的少年林逸，意外获得上古修仙秘籍。从被人嘲笑的废物，到一步步逆袭成为修仙界传奇。灵兽相伴、秘境冒险、宗门纷争，他在修仙之路上披荆斩棘，书写属于自己的传奇人生。',
    chapters: [
      { id: 901, title: '第1话：废物少年', number: 1, updatedAt: '2026-08-01' },
      { id: 902, title: '第2话：奇遇', number: 2, updatedAt: '2026-08-02' },
      { id: 903, title: '第3话：突破', number: 3, updatedAt: '2026-08-04' },
      { id: 904, title: '第4话：入门', number: 4, updatedAt: '2026-08-05' },
    ],
    rating: 4.6,
    views: 123400,
    status: '连载中',
    tags: ['修仙', '逆袭', '奇幻', '冒险'],
    updatedAt: '2026-08-05',
    createdAt: '2026-06-10',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
  {
    id: 10,
    title: '甜蜜的谎言',
    author: '金喜善',
    artist: '李秉宪',
    category: 'romance',
    categoryLabel: '恋爱漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20romance%20manhwa%20cover%20showing%20a%20young%20couple%20sitting%20on%20a%20park%20bench%20under%20cherry%20blossoms%2C%20the%20girl%20laughing%20brightly%20while%20the%20boy%20looks%20at%20her%20with%20affection%2C%20springtime%20atmosphere%2C%20soft%20pastel%20pink%20and%20warm%20tones%2C%20manhwa%20romance%20style%20with%20gentle%20expressions%20and%20flowing%20lines%2C%20dreamy%20and%20heartwarming%20mood&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '为了帮闺蜜出气，苏瑶假装接近渣男学长，却在这个过程中真的爱上了他。当谎言被揭穿，她该如何挽回这段感情？一场始于谎言的爱情，能否用真诚画上完美句号？甜中带虐的青春恋爱物语。',
    chapters: [
      { id: 1001, title: '第1话：计划', number: 1, updatedAt: '2026-07-30' },
      { id: 1002, title: '第2话：接近', number: 2, updatedAt: '2026-08-02' },
      { id: 1003, title: '第3话：心动', number: 3, updatedAt: '2026-08-05' },
    ],
    rating: 4.5,
    views: 89100,
    status: '连载中',
    tags: ['恋爱', '校园', '青春', '甜宠'],
    updatedAt: '2026-08-05',
    createdAt: '2026-06-20',
    isHot: false,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 11,
    title: '剑道至尊',
    author: '元斌',
    artist: '赵寅成',
    category: 'action',
    categoryLabel: '动作漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20powerful%20Korean%20martial%20arts%20manhwa%20cover%20featuring%20a%20swordsman%20in%20flowing%20martial%20arts%20robes%2C%20holding%20a%20glowing%20sword%2C%20standing%20atop%20a%20mountain%20cliff%20at%20sunset%2C%20wind%20blowing%20through%20hair%20and%20clothing%2C%20dramatic%20golden%20and%20crimson%20sky%2C%20manhwa%20action%20style%20with%20dynamic%20energy%20effects%2C%20epic%20and%20heroic%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '剑道天才李云霄惨遭同门背叛，跌落万丈深渊。十年后，他携绝世剑法强势归来。昔日仇人已成一派宗师，而他要用手中之剑，斩尽天下不义，重振剑道荣光。热血沸腾的武侠动作巨制！',
    chapters: [
      { id: 1101, title: '第1话：陨落', number: 1, updatedAt: '2026-07-28' },
      { id: 1102, title: '第2话：重生', number: 2, updatedAt: '2026-07-31' },
      { id: 1103, title: '第3话：归来', number: 3, updatedAt: '2026-08-03' },
      { id: 1104, title: '第4话：复仇', number: 4, updatedAt: '2026-08-05' },
    ],
    rating: 4.8,
    views: 198300,
    status: '连载中',
    tags: ['武侠', '复仇', '热血', '剑道'],
    updatedAt: '2026-08-05',
    createdAt: '2026-05-15',
    isHot: true,
    isNew: false,
    isRecommended: true,
  },
  {
    id: 12,
    title: '秘密花园',
    author: '裴秀智',
    artist: '金秀贤',
    category: 'drama',
    categoryLabel: '剧情漫画',
    cover: 'https://readdy.ai/api/search-image?query=A%20touching%20Korean%20drama%20manhwa%20cover%20showing%20a%20young%20woman%20tending%20flowers%20in%20a%20beautiful%20secret%20garden%20hidden%20behind%20an%20old%20wooden%20gate%2C%20sunlight%20streaming%20through%20leaves%2C%20colorful%20blooming%20flowers%2C%20a%20small%20greenhouse%20in%20the%20background%2C%20warm%20and%20nostalgic%20atmosphere%2C%20manhwa%20drama%20style%20with%20soft%20watercolor-like%20rendering&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '失去记忆的女孩在疗养院的花园里遇到了一个神秘的老人，老人每天给她讲一个故事。渐渐地，她发现这些故事与自己的过往有着千丝万缕的联系。一段关于记忆、爱与救赎的温暖故事。',
    chapters: [
      { id: 1201, title: '第1话：遗忘', number: 1, updatedAt: '2026-07-20' },
      { id: 1202, title: '第2话：花园', number: 2, updatedAt: '2026-07-24' },
    ],
    rating: 4.7,
    views: 67800,
    status: '连载中',
    tags: ['剧情', '治愈', '记忆', '温情'],
    updatedAt: '2026-07-24',
    createdAt: '2026-07-01',
    isHot: false,
    isNew: true,
    isRecommended: false,
  },
];